import { ACTION, GenericObject, actionKeyGenerate } from "src/util/utils";

export const MODULE_KEY = "LOCATION_LIST_UPDATE";
export const LocationList_IMPORT_FILE = "LocationList_IMPORT_FILE";
export const LocationList_IMPORT_FILE_SUCCESS = "LocationList_IMPORT_FILE_SUCCESS";
export const LocationList_IMPORT_FILE_FAILED = "LocationList_IMPORT_FILE_FAILED";

export const LocationList_CLEAN_IMPORT_LAYOUT = "LocationList_CLEAN_IMPORT_LAYOUT";
export const LocationList_UPDATE_VALIDATED_IMPORT = "LocationList_UPDATE_VALIDATED_IMPORT";
export const LocationList_UPDATE_VALIDATED_IMPORT_SUCCESS = "LocationList_UPDATE_VALIDATED_IMPORT_SUCCESS";
export const LocationList_UPDATE_VALIDATED_IMPORT_FAILED = "LocationList_UPDATE_VALIDATED_IMPORT_FAILED";

export const KEYS: GenericObject = actionKeyGenerate(MODULE_KEY);

export const LOCATION_LIST_UPDATE_FETCH = KEYS[MODULE_KEY + ACTION.FETCH];

export const fetchLocationListUpdateSummary = (payload: any) => ({
  type: LOCATION_LIST_UPDATE_FETCH,
  payload,
});

export const fetchLocationListUpdateSummarySuccess = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.SUCCESS],
  payload,
});

export const fetchLocationListUpdateSummaryFailed = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.FAILED],
  payload,
});

export const importFile = (payload: any) => ({
  type: LocationList_IMPORT_FILE,
  payload,
});

export const importFileSuccess = (payload: any) => ({
  type: LocationList_IMPORT_FILE_SUCCESS,
  payload,
});

export const importFileFailed = (payload: any) => ({
  type: LocationList_IMPORT_FILE_FAILED,
  payload,
});

export const cleanImportLayout = () => ({
  type: LocationList_CLEAN_IMPORT_LAYOUT,
});

